module.exports = __webpack_public_path__ + "img/bg-pricing.c3040580.jpg";